import { __rest } from 'tslib';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import MuiBox from '@mui/material/Box';
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import { styled } from '@mui/material/styles';
import EllipsisMenu from './EllipsisMenu.js';
import BreadcrumbOption from './BreadcrumbOption.js';
import BreadcrumbMock from './BreadcrumbMock.js';
import { useDynamicEllipsis } from '../hooks/useDynamicEllipsis.js';

const MockEllipsis = styled(MuiBox) `
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  visibility: hidden;
  height: 20px;
`;
const _Breadcrumbs = styled(MuiBreadcrumbs, { shouldForwardProp: prop => !['width'].includes(prop) }) `
  width: ${({ width }) => `${width}px`};
`;
const InternalBreadcrumbs = (_a) => {
    var { options, onItemClick, menuHint, width } = _a, rest = __rest(_a, ["options", "onItemClick", "menuHint", "width"]);
    const { itemsToRender, ref, mockRef } = useDynamicEllipsis(options, width);
    const indexedOptions = useMemo(() => options.map((option, index) => (Object.assign(Object.assign({}, option), { index }))), [options]);
    const startItems = useMemo(() => {
        if (indexedOptions.length > 2) {
            return indexedOptions.slice(0, itemsToRender);
        }
        return [];
    }, [itemsToRender, indexedOptions]);
    const menuItems = useMemo(() => {
        if (indexedOptions.length > 1) {
            return indexedOptions.slice(itemsToRender, indexedOptions.length - 2);
        }
        return [];
    }, [itemsToRender, indexedOptions]);
    const endItems = useMemo(() => indexedOptions.slice(indexedOptions.length - 2), [indexedOptions]);
    return (jsxs(Fragment, { children: [jsx(MockEllipsis, Object.assign({ ref: mockRef }, { children: options.map((option, index) => (jsx(BreadcrumbMock, Object.assign({ withSeparator: index > 0 }, option), option.id))) })), jsxs(_Breadcrumbs, Object.assign({ ref: ref, width: width }, rest, { children: [startItems.map((_a) => {
                        var { index } = _a, option = __rest(_a, ["index"]);
                        return (jsx(BreadcrumbOption, Object.assign({ onClick: () => onItemClick(option, index) }, option), option.id));
                    }), menuItems.length && jsx(EllipsisMenu, { menuItems: menuItems, onItemClick: onItemClick, hint: menuHint }), endItems.map((_a) => {
                        var { index } = _a, option = __rest(_a, ["index"]);
                        return (jsx(BreadcrumbOption, Object.assign({ highlighted: index === options.length - 1, onClick: () => onItemClick(option, index), "data-testid": `breadcrumb-${option.id}` }, option), option.id));
                    })] }))] }));
};

export { InternalBreadcrumbs as default };
//# sourceMappingURL=InternalBreadcrumbs.js.map
